<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.combo"
    item-text="nome"
    item-name="nome"
    item-value="pacoteId"
    :items="combos"
    label="Combos"
    hide-details="auto"
    placeholder="Selecione o combo"
    v-on:change="$emit('onChange')"
    :clearable="true"
  >
    <template slot="no-data"> Nenhum Combo retornado </template>
  </v-select>
</template>

<script>
export default {
  name: "ComboboxCombos",
  props: ["filter"],
  mounted() {
    // this.loadPacotes();
  },
  methods: {
    //   loadPacotes() {
    //     pacoteAPI
    //       .list()
    //       .then((resp) => {
    //         this.pacotes = resp.data;
    //       })
    //       .catch();
    //   },
  },
  data() {
    return {
      combos: [
        "Combo Essencial",
        "Combo Premium",
        "Combo Ultimate",
        "Combo Plus ou Flex",
      ],
    };
  },
};
</script>
